import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { registerKnowledgeBaseQueryLegendSync } from "@/state/knowledgeBaseDocumentsLegend";

/** Subscribes to RQ cache and patches bounded Legend projection (one-way). */
export function KnowledgeBaseLegendSync() {
  const queryClient = useQueryClient();
  useEffect(() => registerKnowledgeBaseQueryLegendSync(queryClient), [queryClient]);
  return null;
}
